export default "__VITE_ASSET__10f4070d__"